import { Component, OnInit, HostListener, AfterViewInit } from '@angular/core';
import { DegreeType, GraduationType, StudyType, Faculty, Programme, ProgrammeStream, YearLevel, QuotationDetail, AcademicYear } from 'src/app/services/domain.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { QuotationsService } from '../services/quotations.service';
import { Router } from '@angular/router';
import { GlobalsService } from '../services/globals.service';
import { of, forkJoin, Observable } from 'rxjs';
import { StudentType } from '../services/enums.service';
import { DataService } from '../services/data.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';

@Component({
  selector: 'app-programme',
  templateUrl: './programme.component.html',
  styleUrls: ['./programme.component.less']
})
export class ProgrammeComponent implements OnInit {
  labelFloat: string = "always";
  academicYears: Array<AcademicYear> = []
  degreeTypes: Array<DegreeType> = [];
  gradTypes: Array<GraduationType> = [];
  studyTypes: Array<StudyType> = [];
  faculties: Array<Faculty> = [];
  programmes: Array<Programme> = [];
  streams: Array<ProgrammeStream> = [];
  yearLevels: Array<YearLevel> = [];

  quotationDetail: QuotationDetail = { studentType: StudentType.local, academicYear: 0, degreeTypeId: "",    degreeTypeName: "", 
      gradTypeId: "", gradTypeName: "", studyTypeId: "", studyTypeName: "", facultyId: "", facultyName: "", programmeId: 0, 
      programmeName: "", streamId: "", streamName: "", yearLevelId: 0, yearLevelName: "", quotationsModules: [], programmeDuration: 0, chargeByModule: true, programmeCost: 0,
      includeRes: false, generateQuotation: false, generateProforma: false, residence: undefined, personalInfo: undefined, proformaInfo: undefined };

  programmeForm: FormGroup;
  prevSelectedProgramme: number = 0;
  prevSelectedYearLevel: number = 0;

  constructor(private formBuilder: FormBuilder,
    private service: QuotationsService,
    private globals: GlobalsService,
    private router: Router,
    private data: DataService,
    private notifier: SnotifyService) { }

  ngOnInit() {
    if(window.innerWidth < 600) {
      this.labelFloat = "auto";
    }

    this.data.changePage("programme");
    this.data.isLoading(true);

    this.programmeForm = this.formBuilder.group({
      academicYearControl: new FormControl(0, Validators.min(1)),
      degreeTypeControl: new FormControl('', Validators.required),
      gradTypeControl: new FormControl('', Validators.required),
      studyTypeControl: new FormControl('', Validators.required),
      facultyControl: new FormControl('', Validators.required),
      programmeControl: new FormControl(0, Validators.min(1)),
      streamControl: new FormControl(''),
      yearLevelControl: new FormControl(0, Validators.min(1))
    });

    this.loadProgrammeData().subscribe(response => {
      this.academicYears = response[0] as Array<AcademicYear>;
      this.degreeTypes = response[1] as Array<DegreeType>;
      this.gradTypes = response[2] as Array<GraduationType>;
      this.studyTypes = response[3] as Array<StudyType>;
      this.faculties = response[4] as Array<Faculty>;

      if(this.globals.quotationDetail) {
        this.quotationDetail = this.globals.quotationDetail;
        this.prevSelectedProgramme = this.quotationDetail.programmeId;
        this.prevSelectedYearLevel = this.quotationDetail.yearLevelId;
      }
    }, error => {
      this.data.isLoading(false);
      console.log("Error on loadProgrammeData() : ", error);
      this.showError('loadProgrammeData');
    }, () => {
      this.programmeFilterOnLoad().subscribe(response => {
        this.programmes = response[0] as Array<Programme>;
        this.programmeChanged(this.quotationDetail.programmeId);

        this.programmeForm.setValue({
          academicYearControl: this.quotationDetail.academicYear,
          degreeTypeControl: this.quotationDetail.degreeTypeId,
          gradTypeControl: this.quotationDetail.gradTypeId,
          studyTypeControl: this.quotationDetail.studyTypeId,
          facultyControl: this.quotationDetail.facultyId,
          programmeControl: this.quotationDetail.programmeId,
          streamControl: this.quotationDetail.streamId,
          yearLevelControl: this.quotationDetail.yearLevelId
        });
      }, error => {
        this.data.isLoading(false);
        console.log("Error on programmeFilterOnLoad(): ", error);
        this.showError('programmeFilterOnLoad');
      }, () => {
        this.data.isLoading(false);
      });
    });
  }

  loadProgrammeData(): Observable<any[]> {
    let response1 = this.service.getAcademicYears();
    let response2 = this.service.getDegreeTypes();
    let response3 = this.service.getGraduationTypes();
    let response4 = this.service.getStudyTypes();
    let response5 = this.service.getFaculties();

    return forkJoin(response1, response2, response3, response4, response5);
  }

  programmeFilterOnLoad(): Observable<any[]> {
    let programmes = this.service.getProgrammes(this.quotationDetail.academicYear, this.quotationDetail.degreeTypeId,
      this.quotationDetail.gradTypeId, this.quotationDetail.studyTypeId, this.quotationDetail.facultyId);

    return forkJoin(programmes);
  }

  programmeFilterChange() {
    this.programmes = [];
    this.streams = [];
    this.yearLevels = [];

    //Clear previously selected programme
    if(this.quotationDetail){
      this.quotationDetail.programmeId = 0;
      this.quotationDetail.streamId = "";
      this.quotationDetail.yearLevelId = 0;

      this.programmeForm.setValue({
        academicYearControl: this.quotationDetail.academicYear,
        degreeTypeControl: this.quotationDetail.degreeTypeId,
        gradTypeControl: this.quotationDetail.gradTypeId,
        studyTypeControl: this.quotationDetail.studyTypeId,
        facultyControl: this.quotationDetail.facultyId,
        programmeControl: this.quotationDetail.programmeId,
        streamControl: this.quotationDetail.streamId,
        yearLevelControl: this.quotationDetail.yearLevelId
      });
    }

    let canFilter: boolean = false;
    if(this.quotationDetail.academicYear != 0 && this.quotationDetail.degreeTypeId != "" &&
      this.quotationDetail.gradTypeId != "" && this.quotationDetail.studyTypeId != "" && this.quotationDetail.facultyId != "") {
        canFilter = true;
      }

    if(canFilter) {
      this.data.isLoading(true);
       this.service.getProgrammes(this.quotationDetail.academicYear, this.quotationDetail.degreeTypeId,
        this.quotationDetail.gradTypeId, this.quotationDetail.studyTypeId, this.quotationDetail.facultyId).subscribe(result => {
          this.programmes = result as Array<Programme>;
        }, error => {
          this.data.isLoading(false);
          console.log('Error on programmeFilterChange(): ', error)
          this.showError('programmeFilterChange');
        }, () => {
          this.data.isLoading(false);
        });
    }
  }

  programmeChanged(id: number) {
    this.streams = []
    this.yearLevels = []

    let programme: Programme = this.programmes.find(p => p.id == id);
    if(programme) {
      if(programme.streams) {
        this.streams = programme.streams;
      }

      if(programme.yearLevels) {
        this.yearLevels = programme.yearLevels
      }
    }
  }

  proceed() {
    if(this.programmeForm.valid) {
      //If programme or year level has changed, remove any previously selected modules
      if(this.quotationDetail.quotationsModules && this.quotationDetail.quotationsModules.length > 0) {
        if((this.prevSelectedProgramme != 0 && this.prevSelectedProgramme != this.quotationDetail.programmeId) ||
          (this.prevSelectedYearLevel != 0 && this.prevSelectedYearLevel != this.quotationDetail.yearLevelId)) {
            this.quotationDetail.quotationsModules = [];
        }
      }

      let degreeType: DegreeType = this.degreeTypes.find(dt => dt.id == this.quotationDetail.degreeTypeId);
      if(degreeType) {
        this.quotationDetail.degreeTypeName = degreeType.name;
      } else {
        this.quotationDetail.degreeTypeName = "";
      }

      let gradType: GraduationType = this.gradTypes.find(gt => gt.id == this.quotationDetail.gradTypeId);
      if(gradType) {
        this.quotationDetail.gradTypeName = gradType.name;
      } else {
        this.quotationDetail.gradTypeName = "";
      }

      let studyType: StudyType = this.studyTypes.find(st => st.id == this.quotationDetail.studyTypeId);
      if(studyType) {
        this.quotationDetail.studyTypeName = studyType.name;
      } else {
        this.quotationDetail.studyTypeName = "";
      }

      let faculty: Faculty = this.faculties.find(f => f.id == this.quotationDetail.facultyId);
      if(faculty) {
        this.quotationDetail.facultyName = faculty.name;
      } else {
        this.quotationDetail.facultyName = "";
      }

      let programme: Programme = this.programmes.find(p => p.id == this.quotationDetail.programmeId);
      if(programme) {
        this.quotationDetail.programmeName = programme.name;
      } else {
        this.quotationDetail.programmeName = "";
      }

      let stream: ProgrammeStream = this.streams.find(s => s.id == this.quotationDetail.streamId);
      if(stream) {
        this.quotationDetail.streamName = stream.name;
      } else {
        this.quotationDetail.streamName = "";
      }

      let yearLevel: YearLevel = this.yearLevels.find(yl => yl.id == this.quotationDetail.yearLevelId);
      if(yearLevel) {
        this.quotationDetail.yearLevelName = yearLevel.name;
      } else {
        this.quotationDetail.yearLevelName = "";
      }

      this.quotationDetail.programmeDuration = this.yearLevels.length;

      this.data.isLoading(true);
      this.service.hasAcademicRules(this.quotationDetail.academicYear, programme.id, this.quotationDetail.streamId, yearLevel.id).subscribe(result => {
        var hasAcademicRules = result as boolean;
        if(hasAcademicRules){
          this.globals.quotationDetail = this.quotationDetail;
          this.router.navigate(['/default', {outlets: {'main': ['modules']}}]);
        } else {
          this.notifier.warning('Programme not available for Online Quoations or Pro-forma Invoices.  Please select another Programme or contact the Faculty.', {
            timeout: 0,
            position: SnotifyPosition.centerCenter,
            closeOnClick: false,
            buttons: [
              {text: 'Ok'}
            ]
          });
        }
      }, error => {
        this.data.isLoading(false);
        console.log("error in hasAcademicRules: ", error);
        this.showError('hasAcademicRules');
      }, () => {
        this.data.isLoading(false);
      });
    }
  }

  @HostListener('window:resize', ['$event']) 
  onResize(event){
    if(event.target.innerWidth < 600) {
      this.labelFloat = "auto";
    }
    else {
      this.labelFloat = "always";
    }
  }

  showError(source: string){
    this.notifier.error('An error occurred at ' + source + '. Please try again and if the problem persists, please contact support at servicedesk@uwc.ac.za', {
      timeout: 0,
      position: SnotifyPosition.centerCenter,
      closeOnClick: false,
      buttons: [
        {text: 'Ok'}
      ]
    });
  }

  get academicYearControl() { return this.programmeForm.get('academicYearControl') };
  get degreeTypeControl() { return this.programmeForm.get('degreeTypeControl') };
  get gradTypeControl() { return this.programmeForm.get('gradTypeControl') };
  get studyTypeControl() { return this.programmeForm.get('studyTypeControl') };
  get facultyControl() { return this.programmeForm.get('facultyControl') };
  get programmeControl() { return this.programmeForm.get('programmeControl') };
  get streamControl() { return this.programmeForm.get('streamControl') };
  get yearLevelControl() { return this.programmeForm.get('yearLevelControl') };
}
